import axios from 'axios'

import type { components, operations } from '../constants/schema'

type GetEventListParams = Required<operations['EventController_findAll']['parameters']>['query']

/**
 * 이벤트 목록
 * @param offset pagination
 * @param size call 한 번에 불러오는 개수
 * @returns ResListEvent
 */
export const getEventList = async ({ offset = 0, size = 50 }: GetEventListParams) => {
  return (await axios.get<components['schemas']['ResListEvent']>('/event', { params: { offset, size } })).data
}

/**
 * 이벤트 상세 정보
 * @param eventId 이벤드 id
 * @returns EventCurrentDto
 */
export const getEventDetail = async (eventId: number) => {
  return (await axios.get<components['schemas']['EventCurrentDto']>(`/event/${eventId}`)).data
}

/**
 * 이벤트 약관 동의
 * @param eventId 이벤트 id
 * @param data ReqUserAddUserTerms
 * @returns EventCurrentDto | undefined
 */
export const approveEvent = async ({
  eventId,
  data,
}: {
  eventId: number
  data: components['schemas']['ReqUserAddUserTerms']
}) => {
  try {
    return (await axios.post<components['schemas']['EventCurrentDto']>(`/event/${eventId}/approve`, data)).data
  } catch (error) {
    throw error
  }
}
